import { format } from "date-fns";

export const LeaveApplicationsColumns = [
  { field: "Id", headerName: "ID", flex: 0.3 },

  {
    field: "StartDate",
    headerName: "Start Date",
    flex: 1,
    type: "date",
    renderCell: (params) => {
      const formatDate = format(new Date(params.value), "MM/dd/yyy");
      return formatDate;
    },
  },
  {
    field: "EndDate",
    headerName: "End Date",
    flex: 1,
    type: "date",
    renderCell: (params) => {
      const formatDate = format(new Date(params.value), "MM/dd/yyy");
      return formatDate;
    },
  },
  {
    field: "ResumptionDate",
    headerName: "Resumption Date",
    flex: 1.5,
    type: "date",
    renderCell: (params) => {
      const formatDate = format(new Date(params.value), "MM/dd/yyy");
      return formatDate;
    },
  },

  // { field: "StatusDescription", headerName: "Status", flex: 1 },

  { field: "LeaveType", headerName: "Leave Type", flex: 1.3 },
  { field: "FirstName", headerName: "First Name", flex: 1 },
  { field: "LastName", headerName: "Last Name", flex: 1 },
  { field: "PhoneNumber", headerName: "Phone Number", flex: 1.5 },
  { field: "Email", headerName: "Email", flex: 1.5 },
];
export const AllPoliciesColumns = [
  { field: "Id", headerName: "ID", flex: 0.5 },
  { field: "LeaveType", headerName: "Leave Type", flex: 1 },
  { field: "Gender", headerName: "Gender", flex: 1 },
  { field: "Acrues", headerName: "Acrues", flex: 1},

  {
    field: "AccrualRate",
    headerName: "Accrual Rate",
    flex: 1,
  },
  {
    field: "AccrualDate",
    headerName: "Accrual Date",
    flex: 1,
    type: "date",
    renderCell: (params) => {
      const formatDate = format(new Date(params.value), "MM/dd/yyy");
      return formatDate;
    },
  },
  {
    field: "CanCarryForward",
    headerName: "Carry Forward",
    flex: 1.5,
    type: "boolean",
  },
  {
    field: "MaxDaysCarryForward",
    headerName: "Max Days Carry Forward",
    flex: 1,
  },
  {
    field: "MaxOpenApplications",
    headerName: "Max Open Applications",
    flex: 1,
  },

  { field: "MaxDays", headerName: "Max Days", flex: 1 },
];
export const LeaveApproversColumns = [
  { field: "Id", headerName: "ID", flex: 0.3 },
  { field: "UserId", headerName: "UserID", flex: 0.3 },
  { field: "FirstName", headerName: "First Name", flex: 1.3 },
  { field: "LastName", headerName: "Last Name", flex: 1.3 },
  { field: "PhoneNumber", headerName: "Phone No.", flex: 1.3 },
  { field: "Email", headerName: "Email", flex: 1.3 },
  { field: "Role", headerName: "Role", flex: 0.7 },
  { field: "RoleGroup", headerName: "Role Group", flex: 1.3},
  { field: "Branch", headerName: "Branch", flex: 1 },
  { field: "Region", headerName: "Region", flex: 1 },
];
export const CompanyCalendarSetupsColumns = [
  { field: "Id", headerName: "ID", flex: 0.3 },
  { field: "RecurringTypeId", headerName: "Recurring Type ID", flex: 1 },
  { field: "RecurringType", headerName: "Recurring Type", flex: 1 },
  { field: "Holiday", headerName: "Holiday", flex: 1 },
];
export const DisbursementTypesColumns = [
  { field: "Id", headerName: "ID", flex: 0.3 },
  { field: "Type", headerName: "Disbursement type", flex: 1 },
  
];
export const userFinanceDetailsColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "bankBranch", headerName: "Bank Branch", flex: 1 },
  { field: "bank", headerName: "Bank", flex: 1 },
  { field: "accountNumber", headerName: "Account Number", flex: 2},
  { field: "mpesaNumber", headerName: "Mpesa Number", flex: 1 },
];

export const requisitionApproversColumns = [
  { field: "Id", headerName: "ID", flex: 0.3 },
  { field: "FirstName", headerName: "First Name", flex: 1.3},
  { field: "LastName", headerName: "Last Name", flex: 1.3 },
  { field: "PhoneNumber", headerName: "Phone No.", flex: 1.3 },
  { field: "Email", headerName: "Email", flex: 1 },
  { field: "Role", headerName: "Role", flex: 0.7 },
  { field: "RoleGroup", headerName: "Role Group", flex: 1.3},
  { field: "Branch", headerName: "Branch", flex: 1 },
  { field: "Region", headerName: "Region", flex: 1 },
];

export const imprestApplicationsColumns = [
  { field: "Id", headerName: "ID", flex: 0.3},
  { field: "DisbursementType", headerName: "Disbursement Type", flex: 1.2},
  { field: "Title", headerName: "Title", flex: 2 },
  { field: "Description", headerName: "Description", flex: 2 },
  { field: "Amount", headerName: "Amount", flex: 1 },
  { field: "FirstName", headerName: "First Name", flex: 1 },
  { field: "LastName", headerName: "Last Name", flex: 1 },
  { field: "PhoneNumber", headerName: "Phone Number", flex: 2 },
  { field: "Email", headerName: "Email", flex: 2 },
  { field: "Branch", headerName: "Branch", flex: 1 },
  { field: "Region", headerName: "Region", flex: 1 },
];

export const staffClaimApplicationsColumns = [
  { field: "Id", headerName: "ID", flex: 0.2 },
  { field: "TotalAmount", headerName: "Total Amt ", flex: 1 },

  {
    field: "Status",
    headerName: "Status",
    flex: 1.3,
    type: "boolean",
    renderCell: (params) => {
      const values = params.value === 0 ? "No" : "Yes";
      const coloredColor = values === "No" ? "red" : "green";
      return <div style={{ color: coloredColor }}>{values}</div>;
    },
  },

  { field: "StatusDescription", headerName: "Status ", flex: 0.7 },

  { field: "ApplicantFirstName", headerName: "Applicant First Name", flex: 1 },
  { field: "ApplicantLastName", headerName: "Applicant Last Name", flex: 1 },
  { field: "Branch", headerName: "Branch", flex: 0.7},
  { field: "Region", headerName: "Region", flex: 0.7 },
];
export const AllImprestSurrenderColumns = [
  { field: "Id", headerName: "ID", flex: 0.2, required: true },
  { field: "TotalAmount", headerName: "Total Amt", flex: 1, required: true },

  {
    field: "DisbursementType",
    headerName: "Disbursement Type",
    flex: 1.5,
    required: true,
  },
  { field: "Title", headerName: "Title", flex: 0.5, required: true },
  { field: "Description", headerName: "Description", flex: 1.1, required: true },
  { field: "ActualSpent", headerName: "Actual Spent", flex: 1.2, required: true },
  {
    field: "RemainingAmount",
    headerName: "Remaining Amt",
    flex: 1.2,
    required: true,
  },
  {
    field: "StatusDescription",
    headerName: "Status ",
    flex: 0.7,
    required: true,
  },

  { field: "FirstName", headerName: "First Name", flex: 1.1, required: true },
  { field: "LastName", headerName: "Last Name", flex: 1.1, required: true },
  { field: "PhoneNumber", headerName: "Phone No.", flex: 1.1, required: true },

  { field: "Role", headerName: "Role", flex: 0.5, required: true },

  { field: "Branch", headerName: "Branch", flex: 0.6, required: true },
  { field: "R egion", headerName: "Region", flex: 0.6, required: true },
];
export const imprestSurrenderLinesColumns = [
  { field: "Id", headerName: "ID", flex: 0.3, required: true },
  { field: "Amount", headerName: " Amount", flex: 1, required: true },
  { field: "Description", headerName: "Description", flex: 2, required: true },
  { field: "Date", headerName: "Date", flex: 2, required: true },

];
export const staffClaimLinesColumns = [
  { field: "Id", headerName: "ID", flex: 0.3, required: true },
  { field: "Amount", headerName: " Amount", flex: 1, required: true },
  { field: "Description", headerName: "Description", flex: 2, required: true },
];
export const allRelievers = [
  { field: "Id", headerName: "ID", flex: 0.3, required: true },

  {
    field: "LeaveType",
    headerName: "Leave Type",
    flex: 1,
    required: true,
  },

  {
    field: "StatusDescription",
    headerName: "Status ",
    flex: 1,
    required: true,
  },

  {
    field: "ApplicantFirstName",
    headerName: "Applicant First Name",
    flex: 1.5,
    required: true,
  },
  {
    field: "ApplicantLastName",
    headerName: "Applicant Last Name",
    flex: 1.5,
    required: true,
  },
  {
    field: "RelieverFirstName",
    headerName: "Reliever First Name",
    flex: 1.5,
    required: true,
  },
  {
    field: "RelieverLastName",
    headerName: "Reliever Last Name",
    flex: 1.5,
    required: true,
  },

  { field: "Role", headerName: "Role", flex: 1, required: true },

  { field: "Branch", headerName: "Branch", flex: 1, required: true },
  { field: "Region", headerName: "Region", flex: 1, required: true },
];
